import React from "react";

const Loader = () => {
   return (
      <div className="flex justify-center items-center h-[30vh]">
         <div className="relative md:w-20 w-16 md:h-20 h-16 animate-spin rounded-full bg-gradient-to-r from-purple-400 via-[#19e126] to-rose-600 ">
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:w-[68px] w-[52px] md:h-[68px] h-[52px]  bg-black rounded-full border-2 border-white"></div>
         </div>
      </div>
   );
};

export default Loader;
